import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { DisclaimerSubmission } from "../types/panel.type";
import { requireRfxId } from "../utils/requireRfxId";

export const useSubmitDisclaimer = (
	rfxId: number | null | undefined,
	evalId: number
) => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (params: { memberId: number; payload: DisclaimerSubmission }) =>
			apiV2.post(
				`/rfx/${requireRfxId(rfxId, "submit this disclaimer")}/evaluation/${evalId}/panel-members/${params.memberId}/disclaimer`,
				params.payload
			),
		onSuccess: () => {
			// Match the panel query keys used by the member table/status
			// (panelKeys.all → ["evaluation-panel", rfxId, evalId, ...]). The
			// previous ["panel-members"] key matched nothing, so panel data stayed
			// stale until a manual refetch / tab change.
			qc.invalidateQueries({ queryKey: ["evaluation-panel", rfxId, evalId] });
		},
	});
};
